export function createPersistentAdapter({persistentService}) {
    async function save(doc, metadata) {
        const raw = JSON.stringify(doc)
        return persistentService.save(raw, metadata)
    }

    async function load(fromDoc) {
        if (fromDoc != null) {
            const doc = typeof fromDoc === 'string' ? JSON.parse(fromDoc) : fromDoc
            if (doc.version !== 1) {
                // migrate(doc)
            }
            return doc
        }

        const raw = await persistentService.load()
        if (!raw) return null

        const doc = typeof raw === 'string' ? JSON.parse(raw) : raw

        if (doc.version !== 1) {
            // migrate(doc)
        }

        return doc
    }

    return {
        save,
        load,
    }
}
